import { GlobalAdmin } from "coolremote-sdk";
import { ImportResult, ImportRow } from "./deviceImportUtils";

export async function importDevices(devices: ImportRow[]): Promise<ImportResult[]> {
  const response = await GlobalAdmin.importDevices(devices);
  return response?.results ?? [];
}
